import Button from '../../../common/Button/Button';
import IconButton from '../../../common/IconButton/IconButton';
import IconCombo from '../../../common/IconCombo/IconCombo';
import Text from '../../../common/Text/Text';
import './Buttons.scss';

const dropdownOptions = [
  { label: 'Option One', value: 'one', disabled: false },
  { label: 'Option Two', value: 'two', disabled: false },
  { label: 'Option Three', value: 'three', disabled: false },
];

const Buttons = () => {
  /* v8 ignore next -- @preserve */
  const handleClick = () => {};

  return (
    <div className="buttons">
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Button</Text>
          </div>
          <div className="content">
            <Button buttonStyleType="primary" label="Primary" handleClick={handleClick} />
            <Button buttonStyleType="primary" label="Primary" handleClick={handleClick} />
            <Button buttonStyleType="primary" label="Primary" handleClick={handleClick} />
            <Button buttonStyleType="primary" label="Primary" handleClick={handleClick} />
            <Button buttonStyleType="primary" label="Primary" handleClick={handleClick} disabled />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Button - icon right</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Button - icon left</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Button - dropdown</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="primary"
              label="Primary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              disabled
            />
          </div>
        </div>
      </div>
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Button</Text>
          </div>
          <div className="content">
            <Button buttonStyleType="secondary" label="Secondary" handleClick={handleClick} />
            <Button buttonStyleType="secondary" label="Secondary" handleClick={handleClick} />
            <Button buttonStyleType="secondary" label="Secondary" handleClick={handleClick} />
            <Button buttonStyleType="secondary" label="Secondary" handleClick={handleClick} />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Button - icon right</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Button - icon left</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Button - dropdown</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              disabled
            />
          </div>
        </div>
      </div>
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Small Button</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              disabled
              buttonSmall
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Small Button - icon right</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Small Button - icon left</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              disabled
              buttonSmall
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Small Button - dropdown</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              buttonSmall
            />
            <Button
              buttonStyleType="primary"
              label="Primary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              buttonSmall
              disabled
            />
          </div>
        </div>
      </div>
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Small Button</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              disabled
              buttonSmall
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Small Button - icon right</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Small Button - icon left</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              disabled
              buttonSmall
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Small Button - dropdown</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="secondary"
              label="Secondary Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              buttonSmall
              disabled
            />
          </div>
        </div>
      </div>
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Button</Text>
          </div>
          <div className="content">
            <Button buttonStyleType="text" label="Text Button" handleClick={handleClick} />
            <Button buttonStyleType="text" label="Text Button" handleClick={handleClick} />
            <Button buttonStyleType="text" label="Text Button" handleClick={handleClick} />
            <Button buttonStyleType="text" label="Text Button" handleClick={handleClick} />
            <Button buttonStyleType="text" label="Text Button" handleClick={handleClick} disabled />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Button - icon right</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronRight"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Button - icon left</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Button - dropdown</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              disabled
            />
          </div>
        </div>
      </div>
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Small Button</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              disabled
              buttonSmall
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Small Button - icon right</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronRight"
              buttonSmall
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Small Button - icon left</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              buttonSmall
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              leftIconName="ChevronLeft"
              disabled
              buttonSmall
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Text Small Button - dropdown</Text>
          </div>
          <div className="content">
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              buttonSmall
              dropdownOptions={dropdownOptions}
            />
            <Button
              buttonStyleType="text"
              label="Text Button Small"
              handleClick={handleClick}
              rightIconName="ChevronDown"
              dropdownOpenIconName="ChevronUp"
              withDropdown
              dropdownOptions={dropdownOptions}
              buttonSmall
              disabled
            />
          </div>
        </div>
      </div>
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Icon Button</Text>
          </div>
          <div className="content">
            <IconButton buttonStyleType="primary" handleClick={handleClick} iconName="Bars" />
            <IconButton buttonStyleType="primary" handleClick={handleClick} iconName="Bars" />
            <IconButton buttonStyleType="primary" handleClick={handleClick} iconName="Bars" />
            <IconButton buttonStyleType="primary" handleClick={handleClick} iconName="Bars" />
            <IconButton
              buttonStyleType="primary"
              handleClick={handleClick}
              iconName="Bars"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Icon Button - combo</Text>
          </div>
          <div className="content">
            <IconCombo
              buttonStyleType="primary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Small Icon Button</Text>
          </div>
          <div className="content">
            <IconButton
              buttonStyleType="primary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="primary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="primary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="primary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="primary"
              handleClick={handleClick}
              iconName="Bars"
              disabled
              size="small"
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Primary Small Icon Button - combo</Text>
          </div>
          <div className="content">
            <IconCombo
              buttonStyleType="primary"
              handleLeftButtonClick={handleClick}
              size="small"
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="primary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
              disabled
            />
          </div>
        </div>
      </div>
      <div className="line">
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Icon Button</Text>
          </div>
          <div className="content">
            <IconButton buttonStyleType="secondary" handleClick={handleClick} iconName="Bars" />
            <IconButton buttonStyleType="secondary" handleClick={handleClick} iconName="Bars" />
            <IconButton buttonStyleType="secondary" handleClick={handleClick} iconName="Bars" />
            <IconButton buttonStyleType="secondary" handleClick={handleClick} iconName="Bars" />
            <IconButton
              buttonStyleType="secondary"
              handleClick={handleClick}
              iconName="Bars"
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Icon Button - combo</Text>
          </div>
          <div className="content">
            <IconCombo
              buttonStyleType="secondary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
              disabled
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Small Icon Button</Text>
          </div>
          <div className="content">
            <IconButton
              buttonStyleType="secondary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="secondary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="secondary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="secondary"
              handleClick={handleClick}
              iconName="Bars"
              size="small"
            />
            <IconButton
              buttonStyleType="secondary"
              handleClick={handleClick}
              iconName="Bars"
              disabled
              size="small"
            />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">Secondary Small Icon Button - combo</Text>
          </div>
          <div className="content">
            <IconCombo
              buttonStyleType="secondary"
              handleLeftButtonClick={handleClick}
              size="small"
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
            />
            <IconCombo
              buttonStyleType="secondary"
              size="small"
              handleLeftButtonClick={handleClick}
              leftIconName="Bell"
              rightIconName="Bell"
              handleRightButtonClick={handleClick}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buttons;
